import { render, staticRenderFns } from "./GanttChartV3.vue?vue&type=template&id=5f40ecbb&scoped=true&"
import script from "./GanttChartV3.vue?vue&type=script&lang=js&"
export * from "./GanttChartV3.vue?vue&type=script&lang=js&"
import style0 from "./GanttChartV3.vue?vue&type=style&index=0&id=5f40ecbb&lang=scss&scoped=true&"
import style1 from "./GanttChartV3.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f40ecbb",
  null
  
)

export default component.exports